module.exports = __webpack_public_path__ + "images/fad416f47d1d8bf7e58758245b72d632.svg";